import $ from 'jquery'
import 'jquery-validation/dist/jquery.validate.min'

export default {
  init() {
    $.extend(jQuery.validator.messages, {
      required: 'Ce champs est requis',
      email: 'Cet email n\'est pas valide',
    });

    $('form').validate({
      rules: {
      },
      submitHandler: function(form) {
        form.submit();
      },
    })

    $('#change-avatar').on('change', (e) => {
      this.getBase64(e.target.files[0]).then((b64) => {
        $('.avatar-image').css({
          backgroundImage: `url(${b64})`,
        })
      })
    })
  },
  getBase64(file){
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        res(reader.result);
      };
      reader.onerror = function (error) {
        rej(error);
      };
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent-mes-coordonnees.js